import { render, staticRenderFns } from "./Helpful.vue?vue&type=template&id=c5f72332&scoped=true"
import script from "./Helpful.vue?vue&type=script&lang=js"
export * from "./Helpful.vue?vue&type=script&lang=js"
import style0 from "./Helpful.vue?vue&type=style&index=0&id=c5f72332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f72332",
  null
  
)

export default component.exports